import React, { useEffect, useState,useCallback  } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { customer_login, messageClear } from "../store/reducers/authReducer";
import { migrateGuestCart } from "../store/reducers/guestcartReducer";
import toast from "react-hot-toast";
import { FadeLoader } from "react-spinners";
import { Helmet } from "react-helmet";
import { get_card_products, get_wishlist_products } from "../store/reducers/cardReducer";

const Login = () => {
  const originUrl = window.location.origin;
  const [state, setState] = useState({
    email: "",
    password: "",
  });
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loader, errorMessage, successMessage, userInfo } = useSelector(state => state.auth);
  const { migrationLoading } = useSelector(state => state.guestcart); // En lugar de state.cart

  const inputHandle = e => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };

  const login = e => {
    e.preventDefault();
    dispatch(customer_login(state))
      .unwrap()
      .then(() => {
        // Éxito en login se manejará en el useEffect
      })
      .catch(error => {
        console.error("Error en login:", error);
      });
  };

  useEffect(() => {
    console.error("Mensaje de successMessage dentro de useEffecr:", successMessage);
    if (successMessage) {
      toast.success(successMessage);
      dispatch(messageClear());

      // Migración del carrito solo si hay guestId y userInfo está disponible
      const guestId = localStorage.getItem("guestId");
      if (guestId && userInfo?.id) {
        console.log("Iniciando migración de carrito...");
        dispatch(
          migrateGuestCart({
            userId: userInfo.id,
            guestId,
          })
        )
          .unwrap()
          .catch(error => {
            console.error("Error en migración:", error);
            toast.error(error?.errorMessage || "Error al migrar el carrito");
          });
      }
    }

    if (errorMessage) {
      toast.error(errorMessage);
      dispatch(messageClear());
    }
  }, [successMessage, errorMessage, dispatch, userInfo]);

  // Redirección mejorada
 /* useEffect(() => {
    if (userInfo?.id) {
      const timer = setTimeout(() => {
        const redirectPath = sessionStorage.getItem("redirectPath") || "/";
        const shippingData = sessionStorage.getItem("shippingData");

        if (shippingData) {
          navigate("/envio", { state: JSON.parse(shippingData) });

          loadUserData(userInfo.id);
          sessionStorage.removeItem("shippingData");
        } else {
          navigate(redirectPath);
        }
        sessionStorage.removeItem("redirectPath");
      }, 500); // Pequeño delay para asegurar procesamiento

      return () => clearTimeout(timer);
    }
  }, [userInfo, navigate]); // <- loadUserData ahora está incluido

*/

  // 1. Define loadUserData usando useCallback
  const loadUserData = useCallback((userId) => {
    // Asumo que tienes acciones como get_card_products y get_wishlist_products
    // Asegúrate de que estén importadas
    dispatch(get_card_products(userId));
    dispatch(get_wishlist_products(userId));
  }, [dispatch]); // Solo depende de dispatch, que es estable

  // 2. Tu useEffect ahora es seguro
  useEffect(() => {
    if (userInfo?.id) {
      const timer = setTimeout(() => {
        const redirectPath = sessionStorage.getItem("redirectPath") || "/";
        const shippingData = sessionStorage.getItem("shippingData");

        if (shippingData) {
          navigate("/envio", { state: JSON.parse(shippingData) });

          loadUserData(userInfo.id); // Llama a la función estable
          sessionStorage.removeItem("shippingData");
        } else {
          navigate(redirectPath);
        }
        sessionStorage.removeItem("redirectPath");
      }, 500); // Pequeño delay para asegurar procesamiento

      return () => clearTimeout(timer);
    }
  }, [userInfo, navigate, loadUserData]);



  return (
    <div>
      {loader && (
        <div className="w-screen h-screen flex justify-center items-center fixed left-0 top-0 bg-[#38303033] z-[999]">
          <FadeLoader />
        </div>
      )}

      {migrationLoading && (
        <div className="w-screen h-screen flex justify-center items-center fixed left-0 top-0 bg-[#38303033] z-[999]">
          <div className="bg-white p-6 rounded-lg shadow-lg text-center">
            <FadeLoader />
            <p className="mt-4 text-slate-600">Migrando tu carrito...</p>
          </div>
        </div>
      )}

      <Header />
      <Helmet>
        <title>Iniciar sesión | Tekos.pe</title>
        <meta name="description" content="Compra zapatillas Adidas al mejor precio en Tekos. Envíos a todo Perú." />
        <meta name="keywords" content="zapatillas, Adidas, ofertas, calzado deportivo" />
      </Helmet>
      {/* Resto del componente */}
      <div className="bg-slate-200 min-h-screen py-8 px-4 sm:px-6 lg:px-8">
        <div className="flex justify-center items-center">
          {/* Contenedor principal - cambia a columna en móvil */}
          <div className="w-full max-w-6xl bg-white rounded-md shadow-md overflow-hidden">
            <div className="grid grid-cols-2  sm:grid-cols-1">
              {/* Formulario (primero en móvil) */}
              <div className="p-6 md:p-8">
                <h2 className="text-center w-full text-xl text-slate-600 font-bold">Iniciar sesión </h2>

                <form onSubmit={login} className="text-slate-600">
                  <div className="flex flex-col gap-1 mb-2">
                    <label htmlFor="email">Correo electrónico</label>
                    <input
                      onChange={inputHandle}
                      value={state.email}
                      className="w-full px-3 py-2 border border-slate-200 outline-none focus:border-pink-custom rounded-md"
                      type="email"
                      name="email"
                      id="email"
                      placeholder="Correo electrónico"
                      required
                    />
                  </div>
                  <div className="flex flex-col gap-1 mb-2">
                    <label htmlFor="password">Contraseña</label>
                    <input
                      onChange={inputHandle}
                      value={state.password}
                      className="w-full px-3 py-2 border border-slate-200 outline-none focus:border-pink-custom rounded-md"
                      type="password"
                      name="password"
                      id="password"
                      placeholder="Contraseña"
                      required
                    />
                  </div>
                  <div className="text-right text-slate-600 pt-1">
                    <p>¿Olvidaste la contraseña? </p>
                  </div>
                  <button className="px-8 w-full py-2 bg-[#ae1d22] shadow-lg hover:shadow-pink-500/40 text-white rounded-md">INICIAR SESIÓN</button>
                </form>
                <div className="text-center text-slate-600 mt-4">
                  <p>¿Aún no tienes una cuenta? </p>
                  <Link to="/register">
                    <div className="mt-2 px-8 w-full py-2 bg-white border-2 border-pink-custom hover:bg-pink-50 text-gray-800 rounded-md transition-colors">CREA TU CUENTA</div>
                  </Link>
                </div>
              </div>
              {/* Imagen (oculta en móvil) */}
              <div className="sm:hidden  bg-gray-100">
                <img src={`${originUrl}/images/login.jpg`} alt="Registro" className="w-full h-full object-cover" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Login;
